@if (isCrossGameAdmin) {
  <app-cross-game-admin-view-faqs></app-cross-game-admin-view-faqs>
} @else {
  <app-game-admin-view-faqs></app-game-admin-view-faqs>
}
